<template>
    <span v-show="false"></span>
</template>
<script>
import store from '../store'
import { map, uniqBy } from 'lodash'

export default {
  name: 'InitialData',
  data () {
    return { ...window.vueData.initialData }
  },
  computed: {
    getDataKeyActionSetupLookup () {
      return {
        allAttributes: 'setAllAttributes',
        allSimilars: 'setAllSimilars',
        cartData: 'setCartData',
        productBadges: 'setProductBadges',
        config: 'setConfig',
        products: 'setLiveProducts',
        selectedProductCodeId: 'setSelectedProductCodeId',
        previewOrder: 'setPreviewOrderData',
        relatedSimilarData: 'setRelatedSimilarData',
        similarsActive: 'setSimilarsActive',
        similarFilterQueryStringVar: 'setSimilarFilterQueryStringVar',
        activeSimilarFilters: 'setActiveSimilarFilters',
        similarRecordsUsed: 'setSimilarRecordsUsed',
        uriWithoutOffset: 'setUriWithoutOffset',
        isTopLevelCategory: 'setIsTopLevelCategory',
        productCategoryData: 'setProductCategoryData',
        mapPoints: 'setMapPoints'
      }
    }
  },
  mounted () {
    for (const [dataKey, actionSetup] of Object.entries(this.getDataKeyActionSetupLookup)) {
      if (!(dataKey in this)) {
        continue
      }
      this.$store.dispatch(actionSetup, this[dataKey])
    }

    if (this.hasOwnProperty('listingSimilarGroupCombos')) {
      const listingSimilarGroupCombosUnique = map(this.listingSimilarGroupCombos, (combo) => {
        combo.similars = uniqBy(combo.similars, 'similarId').sort((a, b) => parseInt(a.similarOrder) - parseInt(b.similarOrder))
        combo.similarGroupStep = Number(combo.similarGroupStep)
        return combo
      })
      listingSimilarGroupCombosUnique.sort((a, b) => parseInt(a.similarGroupOrder) - parseInt(b.similarGroupOrder))
      store.dispatch('setListingSimilarGroupCombos', listingSimilarGroupCombosUnique)
    }
  },
  methods: {
    checkConnectionStatus () {
      this.$store.dispatch('setOnlineStatus', navigator.onLine)
    }
  },
  created () {
    this.checkConnectionStatus()
    window.addEventListener('offline', this.checkConnectionStatus)
    window.addEventListener('online', this.checkConnectionStatus)
  },
  destroyed () {
    window.removeEventListener('offline', this.checkConnectionStatus)
    window.removeEventListener('online', this.checkConnectionStatus)
  }
}
</script>
